import React, { FC } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import styled from 'styled-components';

import { useGetApplication, useSubmitStepIsLoading } from '~/controllers/wizard';
import { useDraftIsStale } from '~/controllers/draft';
import theme from '~/constants/theme';
import { isReadOnly } from '~/utils/isReadOnly';
import Button, { ButtonProps } from '~/components/Button';

interface Props extends ButtonProps {
  formName?: string;
  children?: React.ReactNode;
}

const WizardContinueButton: FC<Props> = (props) => {
  const { formName, disabled, children, ...rest } = props;
  const globeState = useSelector((state: any) => state.state);
  const { t } = useTranslation();
  const pathName = useLocation();
  const isItcardholderFlow = pathName?.pathname?.split('/')?.includes('cardHolder');
  const [isLoading] = useSubmitStepIsLoading();
  const { isStale } = useDraftIsStale();
  const { hierarchyErr } = globeState;
  const applicationQuery = useGetApplication();
  const uneditableStep = isReadOnly(applicationQuery.data, isItcardholderFlow);

  return (
    <StyledButton
      className="WizardContinueButton"
      htmlType="submit"
      form={formName}
      size="large"
      type="primary"
      block
      loading={formName === 'cardOrderDetails' ? hierarchyErr : isLoading}
      disabled={disabled || isStale || uneditableStep}
      {...rest}
    >
      {children ?? t('Continue')}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  @media (max-width: ${theme.breakpoints.xs}px) {
    width: 100% !important;
  }
`;

export default WizardContinueButton;
